import { GET_SALES_ORDERS, ADD_SALES_ORDER, UPDATE_SALES_ORDER_STATUS, UPDATE_SALES_ORDER_PRODUCT_STATUS, UPDATE_SALES_ORDER_PAYMENT, UPDATE_SALES_ORDER_PAY_DATE, SHALLOW_DELETE_SALES_ORDER } from 'redux/actionTypes';

function findSalesOrderIndex(state, salesOrderId) {
    return state.findIndex(salesOrder => salesOrder.id === salesOrderId);
};

export default function salesOrders(state = [], action) {
    switch(action.type) {
        case GET_SALES_ORDERS:
            return [
                ...state,
                ...action.payload
            ];
        case ADD_SALES_ORDER:
            return [
                action.payload,
                ...state
            ];
        case UPDATE_SALES_ORDER_STATUS:
            const statusIndex = findSalesOrderIndex(state, action.payload.id);
            return [
                ...state.slice(0, statusIndex),
                {
                    ...state[statusIndex],
                    status: action.payload.status
                },
                ...state.slice(statusIndex + 1)
            ];
        case UPDATE_SALES_ORDER_PRODUCT_STATUS:
            const statusSOIndex = findSalesOrderIndex(state, action.payload.salesOrderId);
            const statusProductIndex = state[statusSOIndex].products.findIndex(
                product => product.id === action.payload.id
            );
            return [
                ...state.slice(0, statusSOIndex),
                {
                    ...state[statusSOIndex],
                    products: [
                        ...state[statusSOIndex].products.slice(0, statusProductIndex),                        
                        {
                            ...state[statusSOIndex].products[statusProductIndex],
                            status: action.payload.status
                        },
                        ...state[statusSOIndex].products.slice(statusProductIndex + 1)
                        
                    ]
                },
                ...state.slice(statusSOIndex + 1)
            ];
        case UPDATE_SALES_ORDER_PAYMENT:
            const paymentIndex = findSalesOrderIndex(state, action.payload.id);
            return [
                ...state.slice(0, paymentIndex),
                {
                    ...state[paymentIndex],
                    payments: action.payload.payments
                },
                ...state.slice(paymentIndex + 1)
            ];
        case UPDATE_SALES_ORDER_PAY_DATE:
            const payDateIndex = findSalesOrderIndex(state, action.payload.id);
            return [
                ...state.slice(0, payDateIndex),
                {
                    ...state[payDateIndex],
                    paymentDate: action.payload.paymentDate
                },
                ...state.slice(payDateIndex + 1)
            ];
        case SHALLOW_DELETE_SALES_ORDER:
            const deleteIndex = findSalesOrderIndex(state, action.payload.id);
            return [
                ...state.slice(0, deleteIndex),
                ...state.slice(deleteIndex + 1)
            ];
        default:
            return state;
    }
};